import React from 'react';
import { useInView } from 'react-intersection-observer';

// Puedes usar una imagen genérica para el banner o dejarla sin imagen de perfil si prefieres
// import defaultBannerImg2 from '../../assets/images/resources-banner.png'; // Asegúrate de tener una imagen como esta
import defaultBannerImg from '../../assets/images/Modulov2 1.png';
import courseImage from '../../assets/images/modulo1.png';
import meditacionImg from '../../assets/images/meditacion.jpg';
import imgModulo5 from '../../assets/images/Modulov2 5.png';
import portadaImg from '../../assets/images/portada.png';
import nostalgiaImg from '../../assets/images/nostalgia.png';
import nivelesImg from '../../assets/images/niveles.png';
import { Link } from 'react-router-dom';

// Componente para una tarjeta de recurso individual
const ResourceCard = ({ resource, index }) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <Link
      to={resource.link}
      // target="_blank"
      rel="noopener noreferrer"
      ref={ref}
      className={`relative w-full max-w-md mx-auto mb-4 flex flex-col sm:flex-row items-center px-4 py-3 rounded-xl border border-gray-700 bg-black/30 text-white shadow-md shadow-gray-700/30 hover:bg-gray-800 transition-all duration-300 ease-in-out ${
        inView ? "animate-fade-in" : "opacity-0 translate-y-4"
      }`}
      style={{ animationDelay: `${index * 100}ms` }}
    >
      {/* Imagen del recurso a la izquierda (opcional) */}
      {resource.image && (
        <div className="flex-shrink-0 mb-3 sm:mb-0 sm:mr-4">
          <img
            src={resource.image}
            alt={resource.title}
            className="w-20 h-20 object-cover rounded-lg shadow-md"
          />
        </div>
      )}

      {/* Contenido del recurso */}
      <div className="flex-1 text-center sm:text-left">
        <h3 className="font-semibold text-lg sm:text-xl mb-1">{resource.title}</h3>
        <p className="text-sm text-gray-400">{resource.description}</p>
        {resource.type && (
          <span className="mt-2 inline-block px-3 py-1 bg-gray-700 text-gray-200 text-xs rounded-full">
            {resource.type}
          </span>
        )}
      </div>
    </Link>
  );
};

const FreeResourcesPage = () => {
  // Aquí defines tus recursos gratuitos
  const freeResources = [
    {
      title: "Herramienta para aprender a meditar",
      description: "Descubre la meditación en fases propuesta por Vishen Lakiani, llevada al siguiente nivel",
      link: "/cursos/manifiesta/meditacion-7-fases", // Podría ser un PDF descargable o una página interna
      image: meditacionImg, // Ejemplo de imagen
      type: "Aplicación"
    },
    // {
    //     title: "Curso de Reprogramación de Patrones",
    //     description: "Inicia en el viaje que tu mente necesita para ir al siguiente nivel.",
    //     link: "/cursos/manifiesta",
    //     image: courseImage,
    //     type: "Curso"
    // },
    {
      title: "Info de Metafísica y Crecimiento Personal a tu Correo",
      description: "Descubre los principios universales y obten motivación en tu bandeja cada semana.",
      link: "/newsletter", // Enlace a un archivo de audio o página de reproducción
      image: imgModulo5,
      type: "Newsletter"
    },
    {
      title: "Ebook: Afirmaciones de Poder",
      description: "Conceptos clave para cambiar la mentalidad desde la perspectiva de las afirmaciones.",
      link: "/afirmaciones",
      image: portadaImg,
      type: "Ebook"
    },
    // {
    //     title: "Audiolibro: Nostalgia",
    //     description: "Audio que extiende el concepto de nostalgia para poder avanzar a los niveles de conciencia de poder.",
    //     link: "/nostalgia",
    //     image: nostalgiaImg,
    //     type: "Audio"
    // },
    // {
    //     title: "Mini Curso: Fundamentos de Breathwork",
    //     description: "Aprende técnicas básicas de respiración consciente.",
    //     link: "/cursos/mini-breathwork",
    //     image: 'https://via.placeholder.com/80x80/a78bfa/ffffff?text=Curso',
    //     type: "Curso Corto"
    // }
  ];

  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col">
      {/* Fondo gradiente */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950 via-black to-gray-900 opacity-95"></div>

      <main className="relative z-10 flex-grow container mx-auto px-4 py-12 flex flex-col items-center">
        {/* Banner o imagen principal */}
        <img
          src={defaultBannerImg}
          alt="Recursos Gratuitos Banner"
          className="w-full max-w-lg h-40 sm:h-48 object-cover rounded-xl mb-6 border-4 border-gray-700 shadow-lg"
        />

        {/* Título de la sección */}
        <h1 className="text-3xl sm:text-4xl font-bold mb-3 text-center">
          Recursos Gratuitos
        </h1>

        {/* Descripción */}
        <p className="text-base sm:text-lg text-gray-400 text-center max-w-xl mb-10">
          Explora las herramientas especialmente diseñadas para elevar tu nivel de consciencia.
        </p>

        {/* Lista de recursos */}
        <div className="w-full flex flex-col items-center">
          {freeResources.map((resource, index) => (
            <ResourceCard key={index} resource={resource} index={index} />
          ))}
        </div>
      </main>

      <footer className="relative z-10 text-center py-6 text-xs text-gray-600">
        © {new Date().getFullYear()} Gus • Aguiar | En misión de elevar y transformar.
      </footer>
    </div>
  );
};

export default FreeResourcesPage;